module.exports = __webpack_public_path__ + "maven-sq.png";